import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { ROLES } from '../constants/roles';
import { useModuleViewAccess } from '../hooks/useModuleViewAccess';
import ReturnsModule from './store/ReturnsModule';
import WorkflowGuide from './common/WorkflowGuide';

const STORE_ACCESS_ROLES = [
  ROLES.STORE_EXECUTIVE,
  ROLES.STORE_INSPECTOR,
  ROLES.CA_MANAGER,
  ROLES.MRO_MANAGER,
  ROLES.CAMO_QM_MANAGER,
  ROLES.PLANNING_MANAGER,
  ROLES.ACCOUNTABLE_MANAGER,
  ROLES.SUPER_ADMIN
];

const ReturnsPage = () => {
  const location = useLocation();
  const { hasAccess } = useModuleViewAccess('store-returns', STORE_ACCESS_ROLES);
  const state = location.state || {};
  const recordId = state.recordType === 'issuance' ? state.recordId || null : null;

  if (!hasAccess) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Access Denied
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          You do not have permission to access Returns.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Returns
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Process issuance returns and review return history.
      </Typography>
      <WorkflowGuide variant="storeReturns" />
      <ReturnsModule recordId={recordId} recordType="issuance" />
    </Box>
  );
};

export default ReturnsPage;
